import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { SaveParams } from 'utils';

export const TabSwitcher = ({ list, defaultType, setTab, tab, save = {}, saveWidthAction = () => {} }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const checkActive = tab ? tab : info?.tabType ? info?.tabType : defaultType;
    const changeType = (type) => {
        if (setTab) {
            setTab(type);
        } else {
            let params = {

                skip: 0,
                limit: 50,
                page: 1,
                tabType: type,
                ...save,
                ...saveWidthAction(type),
            };
            SaveParams(navigate, { ...params });
        }
    };

    return (
        <div className="buttons-tab-wrapper">
            {list?.map((item, index) => (
                <button
                    key={index}
                    onClick={() => changeType(item?.tabValue)}
                    className={checkActive === item?.tabValue ? 'active-btn' : 'passive-btn'}
                >
                    {item?.title}
                </button>
            ))}
        </div>
    );
};
